import React, { useEffect, useState } from 'react';
import Input from '/Foundation/Common/code/Views/Foundation/Common/Input';
import { useDebounce } from 'use-debounce';
import ModalMenu from '/Foundation/Common/code/Views/Foundation/Common/ModalMenu';

const SparePartsKeys_Header = ({ selectedProduct, setSelectedProduct, setQuery, Categories, Translations, isKeysAndLocks }) => {
    const [searchPhrase, setSearchPhrase] = useState("");
    const [debounceSearchPhrase] = useDebounce(searchPhrase, isKeysAndLocks ? 0 : 50);
    const [autoSearchResults, setAutoSearchResults] = useState();
    const [showModal, setShowModal] = useState(false);
    const [selectedMainCategory, setSelectedMainCategory] = useState();
    const [subCategories, setSubCategories] = useState();
    const [selectedSubCategory, setSelectedSubCategory] = useState();
    const [categoryListProducts, setCategoryListProducts] = useState();

    const mainCategoryKey = "mainCategoryKey";
    const subCategoryKey = "subCategoryKey";

    const mainCategories = Categories?.filter((x) => { return !x.ParentId; })?.sort((a, b) => {
        if (a.Name < b.Name)
            return -1;
        if (a.Name > b.Name)
            return 1;
        return 0;
    });

    const loadSavedMainCategory = () => {
        const savedMainCategory = localStorage.getItem(mainCategoryKey);
        if (savedMainCategory) {
            setSelectedMainCategory(JSON.parse(savedMainCategory));
        }
    }

    useEffect(() => {
        if (!isKeysAndLocks && Categories)
            loadSavedMainCategory();
    }, []);

    useEffect(() => {
        if (selectedProduct && showModal)
            setShowModal(false);
    }, [selectedProduct]);

    useEffect(() => {
        if (selectedMainCategory) {
            const subCategories = Categories.filter((x) => { return x.ParentId === selectedMainCategory.Id });
            setQuery("");
            setSearchPhrase("");
            setSubCategories(subCategories);
            const savedSubCategoryJson = localStorage.getItem(subCategoryKey);
            const savedSubCategory = savedSubCategoryJson ? JSON.parse(savedSubCategoryJson) : null;
            if (savedSubCategory && subCategories?.find(x => x.Id === savedSubCategory.Id))
                setSelectedSubCategory();
            else
                setSelectedSubCategory(null);

            setSelectedProduct(null);
        }
        else
            setSubCategories(null);
    }, [selectedMainCategory]);

    useEffect(() => {
        if (selectedMainCategory)
            localStorage.setItem(mainCategoryKey, JSON.stringify(selectedMainCategory));

        if (selectedSubCategory)
            localStorage.setItem(subCategoryKey, JSON.stringify(selectedSubCategory));

    }, [selectedMainCategory, selectedSubCategory]);

    useEffect(() => {
        if (!selectedSubCategory) {
            setCategoryListProducts(null);
            return;
        }

        fetch(`/api/sitecore/spareparts/getproducts?subcategoryid=${selectedSubCategory.Id}`)
            .then((response) => response.json())
            .then((data) => {
                setCategoryListProducts(data);
                //todo what if no products are found?
            })
            .catch((error) => {
            });

    }, [selectedSubCategory]);

    useEffect(() => {
        if (!debounceSearchPhrase || debounceSearchPhrase.length <= 2 || isKeysAndLocks)
            return;
        const controller = new AbortController();

        let url = isKeysAndLocks ? "/api/sitecore/keysandlocks/search" : "/api/sitecore/spareparts/autocomplete";
        fetch(`${url}?query=${debounceSearchPhrase}&maxNumberOfHits=4`, { signal: controller?.signal })
            .then(res => res.json())
            .then(res => setAutoSearchResults(res))
            .catch(console.log);

        return () => controller.abort("New search phrase");
    }, [debounceSearchPhrase]);

    const onsubmit = (e) => {
        if (!debounceSearchPhrase)
            return;
        setQuery(debounceSearchPhrase);
        setShowModal(false);
        if (setSelectedProduct)
            setSelectedProduct(null);
        setAutoSearchResults(null);
    }

    const getModalContent = () => {
        if (!showModal)
            return null;

        let options, step, placeholder, mainTitle, stepBack, setSelectedItem;
        if (!selectedMainCategory) {
            setSelectedItem = setSelectedMainCategory;
            mainTitle = Translations?.Category;
            placeholder = Translations?.SearchCategory;
            options = mainCategories;
            step = 1;
        } else if (!selectedSubCategory) {
            setSelectedItem = setSelectedSubCategory;
            stepBack = (e) => { setSelectedMainCategory(null) };
            mainTitle = Translations?.Subcategory;
            placeholder = Translations?.SearchSubcategory;
            options = subCategories;
            step = 2;
        } else {
            setSelectedItem = setSelectedProduct;
            stepBack = (e) => { setSelectedSubCategory(null) };
            mainTitle = Translations?.SelectProduct;
            placeholder = Translations?.SearchProduct;
            options = categoryListProducts;
            step = 3;
        }

        return <ModalMenu setSelectedItem={setSelectedItem} stepBack={stepBack} mainTitle={mainTitle} placeholder={placeholder} close={() => { setShowModal(false) }} steps={3} step={step} options={options} />

    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onsubmit();
        }
    };

    return (<div className="sparePartsKeys__Header py-10 thule-container">
        <div className="header__content">
            {Translations?.Title && <h1 className='heading2 mb-0 text-center'>{Translations?.Title}</h1>}

            {Translations?.Description && <div className='mt-4 mb-9 text-color--gray80 paragraph' dangerouslySetInnerHTML={{ __html: Translations?.Description }}></div>}
            <div className='d-flex flex-column align-items-center position-relative'>
                <form className='w-100'>
                    <label htmlFor='searchPhrase'><span className='sr-only'>{Translations?.SearchPlaceHolder}</span></label>
                    <Input autocomplete="off" value={searchPhrase} onKeyDown={(e) => handleKeyPress(e)} clearInput={(e) => { setSearchPhrase("") }} onChange={(e) => { setSearchPhrase(e.target.value) }} type={"text"} placeholder={Translations?.SearchPlaceHolder} id="searchPhrase" leadingIcon="search" />
                    {getModalContent()}
                </form>
                <div className='w-100'>
                    {searchPhrase && autoSearchResults && autoSearchResults.length > 0 &&
                        <div className='autoSearch__results py-3 px-5'>
                            {autoSearchResults.map((resultItem, index) => {
                                return <button key={index} onClick={() => { setSelectedProduct(resultItem); setAutoSearchResults([]) }} className='btn w-100 autoSearch__resultItem py-5'>{isKeysAndLocks ? resultItem.Name : resultItem.ProductName}{resultItem.Color && ` ${resultItem.Color}`} {resultItem.ProductId ? resultItem.ProductId : resultItem.PimId} </button>
                            })}
                        </div>}
                </div>

                {!isKeysAndLocks && <><span className='heading3 d-block my-6'>{Translations.Or}</span>
                    <button onClick={() => { setShowModal(true) }} className='btn thule-btn-secondary w-100'>{Translations?.FindByCategory}</button></>}

            </div>
        </div>
    </div>);
}

export default SparePartsKeys_Header;

